import lang from "./lang";

export const checkouts = [
  {
    name: "visa",
    id: "visa_oplata_merchant_uah",
    checkoutId: "98cb4faae5eaf8f8fe3ab557",
    ikPaymentMethod: "card",
  },
  {
    name: "mastercard",
    id: "mastercard_liqpay_merchant2_uah",
    checkoutId: "98cb4faae5eaf8f8fe3ab557",
    ikPaymentMethod: "card",
  },
  {
    name: "transfer",
    id: "transfer",
    checkoutId: "transfer",
    ikPaymentMethod: "transfer",
  },
  {
    name: "privat24",
    id: "privat24_liqpay_merchant3_uah",
    checkoutId: "98cb4faae5eaf8f8fe3ab557",
    ikPaymentMethod: "privat24",
  },
  {
    name: "test",
    id: "test_interkassa_test_xts",
    checkoutId: "98cb4faae5eaf8f8fe3ab557",
    ikPaymentMethod: "test",
  },
];

export const products = (globals) => {
  return {
    oneLesson: {
      id: "oneLesson",
      price: globals?.prices?.oneLesson,
      name: lang?.nextLesson,
      description: lang?.oneNextLessonChosen,
      buttonCaption: `${lang?.pay} ${globals?.prices?.oneLesson} ${lang?.forOneLesson}`,
      productNumber: {
        // використовується у https://www.rebusmetod.com/wp-admin/admin.php?page=paid-downloads-files та
        // https://www.rebusmetod.com/wp-admin/admin.php?page=paid-downloads-p24-files
        visa: 8,
        mastercard: 8,
        transfer: null,
        privat24: 2,
        test: 8,
      },
    },
    threeLessons: {
      id: "threeLessons",
      price: globals?.prices?.threeLessons,
      name: lang?.threeNextLessons,
      description: lang?.threeNextLessonsChosen,
      buttonCaption: `${lang?.pay} ${globals?.prices?.threeLessons} ${lang?.forThreeLessons}`,
      productNumber: {
        visa: 9,
        mastercard: 9,
        transfer: null,
        privat24: 1,
        test: 9,
      },
    },
    fullCourse: {
      id: "fullCourse",
      price: globals?.prices?.fullCourse,
      name: lang?.fullCourse,
      description: lang?.fullCourseChosen,
      buttonCaption: `${lang?.pay} ${globals?.prices?.fullCourse} ${lang?.forFullCourse}`,
      productNumber: {
        visa: 2,
        mastercard: 2,
        transfer: null,
        privat24: 4,
        test: 2,
      },
    },
    fullCourseSpecialOffer: {
      id: "fullCourseSpecialOffer",
      price: globals?.prices?.fullCourseSpecialOffer,
      name: lang?.fullCourseSpecialOffer,
      description: lang?.fullCourseChosen,
      buttonCaption: `${lang?.pay} ${globals?.prices?.fullCourseSpecialOffer} ${lang?.forFullCourse}`,
      productNumber: {
        visa: 3,
        mastercard: 3,
        transfer: null,
        privat24: 3,
        test: 3,
      },
    },
    oldPrice: { price: globals?.prices?.oldPrice },
  };
};
